import React from 'react';
import moment from 'moment';

class RangeFilter extends React.Component {
    constructor(props) {
        super(props);
        this.isFiltered = this.isFiltered.bind(this);
        this.filter = this.filter.bind(this);
    }

  filter(event) {
    if (!this.refs.min.value && !this.refs.max.value) {
      this.props.filterHandler();
    } else {
      this.props.filterHandler({ callback: this.isFiltered });
    }
  }

  isFiltered(targetValue) {
      let formattedMin;
      let formattedMax;
      let formattedTarget = new Date(targetValue.props.children).getTime();
    
    if (this.refs.min.value && !this.refs.max.value) {
        formattedMin = new Date (moment(this.refs.min.value).set({h:0, m:0, s:0})).getTime();
      return formattedTarget >= formattedMin;
    }

    if (!this.refs.min.value && this.refs.max.value) {
        formattedMax = new Date (moment(this.refs.max.value).set({h:23, m:59, s:59})).getTime();
      return formattedTarget <= formattedMax;
    }
    
    if (this.refs.min.value && this.refs.max.value) {
        formattedMin = new Date (moment(this.refs.min.value).set({h:0, m:0, s:0})).getTime();
        formattedMax = new Date (moment(this.refs.max.value).set({h:23, m:59, s:59})).getTime();        
      return formattedTarget >= formattedMin && formattedTarget <= formattedMax;
    }
  }
    
    render() {
      return (
        <div style={{borderColor:'red'}}>
         	<input ref="min" type="date" className="rangefilter" onChange={this.filter} placeholder="start"/>
          <input ref="max" type="date" className="rangefilter" style={{position: 'relative', left:'4%'}} onChange={this.filter} placeholder="end" />
          </div>
      );
    }
};
  RangeFilter.propTypes = {
    filterHandler: React.PropTypes.func.isRequired,
    textOK: React.PropTypes.string,
  };
  
  RangeFilter.defaultProps = {
    textOK: 'OK',
  };

export default RangeFilter